import { render, staticRenderFns } from "./QuoteTotalCosts.vue?vue&type=template&id=2c964bc4&scoped=true"
import script from "./QuoteTotalCosts.vue?vue&type=script&lang=js"
export * from "./QuoteTotalCosts.vue?vue&type=script&lang=js"
import style0 from "./QuoteTotalCosts.vue?vue&type=style&index=0&id=2c964bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c964bc4",
  null
  
)

export default component.exports